export const updateUserNameReducer = {
  updateUserName: (state, action) => {
    const { firstName, lastName } = action.payload;
    state.firstName = firstName;
    state.lastName = lastName;
  },
};
